import React from 'react';
import { Link } from 'react-router';
import { Trans } from 'react-i18next';

import { APP_POLLS } from 'app/common/constants/services';
import IconNotGood from 'app/components/Subs/icons/IconNotGood';
import Application from './Application';
import AppPolls from './AppPolls';
import enhanceAssignedList from './enhanceAssignedList';
import styles from './AssignedList.scss';


type Props = {
  id: string,
  subsData: Array<Object>,
  handleSwitchChosen: (e: SyntheticEvent<HTMLElement>) => void,
};

const AssignedList = ({ id, subsData, handleSwitchChosen }: Props) => {
  return (
    <div className={styles.root}>
      {subsData.map(data => (data.service === APP_POLLS
        ? <AppPolls {...data} key={data.key + data.service} onSwitchChosen={handleSwitchChosen} />
        : <Application {...data} key={data.key + data.service} onSwitchChosen={handleSwitchChosen} />
      ))}

      {/* Отключено, при возвращении нужно будет доверстать этот компонент */}
      {/* <AppYaClass studentId={id} /> */}

      {!subsData.length
        && <div className={styles.nothing}>
          <div className={styles.notgood}>
            <IconNotGood className={styles.notgoodIcon} />
          </div>
          <div className={styles.nothingText}>
            <Trans i18nKey="subs:no_subscibed_apps">
              Нет подключенных приложений.&nbsp;
              <Link to={`/apps/${id}/not-assigned`}>Подключить</Link>
            </Trans>
          </div>
        </div>}
    </div>
  )
};

export default enhanceAssignedList(AssignedList);
